import { System } from '@ecs/System';
import { Position } from '@components/Position';
import { Velocity } from '@components/Velocity';

export class MovementSystem extends System {
  update(_deltaTime: number): void {
    const entities = this.getEntitiesWithComponents(Position, Velocity);

    for (const entity of entities) {
      const position = entity.getComponent(Position)!;
      const velocity = entity.getComponent(Velocity)!;

      // Update position based on velocity
      position.x += Math.cos(velocity.angle) * velocity.speed;
      position.y += Math.sin(velocity.angle) * velocity.speed;
    }
  }
}